import { useState } from "react";
import { AccountInfo } from "../WeddingInfo/WeddingInfo";
import { FaEllipsisVertical } from "react-icons/fa6";

interface InstaDMProps {
  accountInfos: AccountInfo[];
}

const InstaDM: React.FC<InstaDMProps> = ({ accountInfos }) => {
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);

  // 복사 기능
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("복사되었습니다!"); // 복사 완료 알림
      setOpenMenuIndex(null); // 메뉴 닫기
    });
  };

  return (
    <div className="relative mx-4 mb-6 font-gowun">
      <div className="flex items-center space-x-2 mt-12 mb-6">
        <div className="relative w-10 h-10 rounded-full border-[1px] border-gray-200">
          <img
            src={`${process.env.PUBLIC_URL}/dm.png`}
            alt="DM"
            className="p-2"
          />
        </div>
        <span className="text-2xl font-instagram-logo">Direct Hearts</span>
      </div>

      {/* DM 목록 */}
      <div className="flex flex-col mx-4 mt-4 text-left">
        <div>
          {accountInfos.map((content, index) => (
            <div
              key={index}
              className="flex items-center space-x-2 mb-1 relative -mx-2"
            >
              <div className="w-12 h-12 p-1">
                <img
                  src={content.bankImage}
                  className="w-full h-full object-cover rounded-md"
                />
              </div>
              {/* 프로필 사진 옆에 유저 이름과 메시지를 수직으로 배치 */}
              <div className="flex flex-col ml-3 text-left justify-center flex-1">
                <div className="text-[14px] font-medium text-parentText overflow-hidden text-ellipsis whitespace-nowrap">
                  {content.isGroom ? "신랑측" : "신부측"} {content.familyName}
                </div>
                <div className="text-[12px] text-gray-500 overflow-hidden text-ellipsis whitespace-nowrap">
                  {content.bankName} {content.accountNumber}({content.name})
                </div>
              </div>
              {/* 세로 점 3개 아이콘 버튼 */}
              <button
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400"
                onClick={() =>
                  setOpenMenuIndex(openMenuIndex === index ? null : index)
                }
              >
                <FaEllipsisVertical />
              </button>
              {/* 복사하기 메뉴 */}
              {openMenuIndex === index && (
                <div className="absolute right-8 top-1/2 transform -translate-y-1/2 bg-white text-black text-sm p-2 rounded-md shadow-lg z-10 font-semibold">
                  <button onClick={() => handleCopy(content.accountNumber)}>
                    📋 복사하기
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstaDM;
